import './App.css';
import Header from './components/Header/Header';
import Writters from './components/Writters/Writters';

function App() {
  return (
    <div>
      <Header></Header>
      <Writters></Writters>
    </div>
  );
}

export default App;
